import React, { FC } from 'react';
import { UseTranslate } from '../../hooks/Translate';

export enum AlertType {
  NONE = '',
  ERROR = 'error',
  SUCCESS = 'success',
}

export interface IAlertProps {
  type: AlertType;
  title?: string;
  message?: string;
}

const ICON_COLOR = {
  error: '#F11C53',
  success: '#97D700'
};

const Alert: FC<IAlertProps> = (props) => {
  const [translate] = UseTranslate();

  if (props.type !== AlertType.NONE) {
    let message;

    if (props.message) {
      message = <div className="alert__message mt-1">{translate(props.message)}</div>;
    }

    return (
      <div className={'alert alert-' + props.type + ' small mb-3'}>
        <svg width="20px" height="20px" viewBox="0 0 20 20">
          <circle fill={ICON_COLOR[props.type]} cx="10" cy="10" r="10" />
          <circle fill="#FFFFFF" cx="10" cy="10" r="5" />
          <path
            d="M9.912,4.405 C6.87056788,4.405 4.405,6.87056788 4.405,9.912 C4.405,12.9534321 6.87056788,15.419 9.912,15.419 C12.9534321,15.419 15.419,12.9534321 15.419,9.912 C15.4102123,6.87421532 12.9497847,4.41378772 9.912,4.405 L9.912,4.405 Z M9.912,5.505 C10.1959335,5.50041823 10.468003,5.61872332 10.6582866,5.82951079 C10.8485702,6.04029826 10.9385132,6.32301405 10.905,6.605 L10.462,11.013 L9.362,11.013 L8.92,6.605 C8.88651232,6.32318984 8.97632587,6.0406435 9.16638489,5.82989256 C9.35644392,5.61914162 9.62823956,5.50071003 9.912,5.505 L9.912,5.505 Z M9.912,14.315 C9.30448678,14.315 8.812,13.8225132 8.812,13.215 C8.812,12.6074868 9.30448678,12.115 9.912,12.115 C10.5195132,12.115 11.012,12.6074868 11.012,13.215 C11.0125311,13.5070845 10.896873,13.7873879 10.6905254,13.9941107 C10.4841778,14.2008335 10.204085,14.3170005 9.912,14.317 L9.912,14.315 Z"
            fill={ICON_COLOR[props.type]}
          />
        </svg>
        <div className="alert__title font-weight-bold">{(props.title ?  translate(props.title):'' )} </div>
        {message}
          </div>
          );
          }

          return <></>;
          };

          export default Alert;
